module.exports = __webpack_public_path__ + "static/shape-3f906ae2b9b25aa7ba723af2380eb815.png";